import actions from './actions';
import bookingReducer from '../../../../../jobs/job/bookings/booking/reducer';
import { tableConfig } from '../../../../../../settings/index';

// ------------------------------
// Initial State
// ------------------------------
const initState = {
  recruits: [],
  actions: [],
  loading: false,
  total: 0,
  page: 1,
  pageSize: tableConfig.pageSize,
  column: '',
  order: '',
  filter: '',
};

// ------------------------------
// Action Handlers
// ------------------------------
function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters, page, pageSize, column, order, filter } = payload;

  return {
    ...state,
    recruits: data,
    filters,
    total,
    filteredTotal,
    loading: false,
    page,
    pageSize,
    column,
    order,
    filter,
  };
}

function onClearStore() {
  return { ...initState };
}

// ------------------------------
// Local util functions
// ------------------------------

// ------------------------------
// Exported reducer function.
// ------------------------------
export default bookingReducer({
  [actions.LOAD_REQUEST]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
